var _style, _g, _path, _circle, _circle2, _circle3, _circle4, _rect, _path2, _path3, _path4, _path5, _path6, _circle5, _rect2, _path7, _defs, _g2, _path8, _path9, _path10, _g3, _rect3, _polyline, _rect4, _g4, _g5, _g6, _g7, _rect5, _rect6, _polygon, _circle6, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsvImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 272.8 166.4",
    style: {
      enableBackground: "new 0 0 272.8 166.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FCD2E2;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FCD2E2;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:2.0041,2.0041;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#F8DEEB;}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:none;stroke:#E41859;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#F6E6EE;}\n\t.st8{fill:#FFFFFF;stroke:#E41859;stroke-width:0.21;stroke-miterlimit:10;}\n\t.st9{clip-path:url(#SVGID_4_);}\n\t.st10{fill:#FFDFBB;}\n\t.st11{fill:#FEF5F9;}\n\t.st12{fill:#43444E;}\n\t.st13{fill:#FFEBD3;}\n\t.st14{fill:#FFF4E5;}\n\t.st15{fill:#FED6A7;}\n\t.st16{fill:#4E4F5A;}\n\t.st17{fill:#F4DCE6;}\n\t.st18{opacity:0.53;fill:#F9F2F6;}\n\t.st19{fill:#FFFFFF;stroke:#FFF5FA;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st20{fill:#F7DEEA;}\n\t.st21{opacity:0.2;}\n\t.st22{fill:#FFF5FA;}\n\t.st23{fill:#F4D7E7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 66.4,
    y1: 129.1,
    x2: 66.4,
    y2: 130.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.4,132.2v15.3c0,4.1,3.3,7.4,7.4,7.4h151.5c4.1,0,7.4-3.3,7.4-7.4V51.7c0-4.1-0.9-5-5-5h-13.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 213.5,
    y1: 46.7,
    x2: 212.5,
    y2: 46.7
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.8196,
    y1: 146.3235,
    x2: 166.6562,
    y2: -39.0604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6E6EE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,20.2h164.9c3.7,0,6.7,3,6.7,6.7v112.6c0,3.7-3,6.7-6.7,6.7H54c-3.7,0-6.7-3-6.7-6.7V26.9 C47.3,23.2,50.3,20.2,54,20.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 66.4,
    cy: 31.3,
    r: 3.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 136.4,
    cy: 31.3,
    r: 3.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 171.4,
    cy: 31.3,
    r: 3.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 206.5,
    cy: 31.3,
    r: 3.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.2352,
    y1: 17.7981,
    x2: 153.9752,
    y2: 69.9181,
    gradientTransform: "matrix(1 0 0 -1 0 168.2161)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6E6EE"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126.7,
    y: 40.8,
    className: "st4",
    width: 55,
    height: 104
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.2,61h5.5c3,0,5.5,2.4,5.5,5.5c0,0,0,0,0,0v7.7c0,3,2.5,5.5,5.5,5.5l0,0h1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M150.5,75.1h39c0.7,0,1.4,0.6,1.4,1.3v5.9c0,0.7-0.6,1.3-1.4,1.3h-39c-0.7,0-1.3-0.6-1.3-1.3v-5.9 C149.1,75.7,149.8,75.1,150.5,75.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M156,78.5H184c0.5,0,0.9,0.4,0.9,0.9l0,0c0,0.5-0.4,0.9-0.9,0.9H156c-0.5,0-0.9-0.4-0.9-0.9l0,0 C155.2,78.9,155.6,78.5,156,78.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.6,97.2h39c0.7,0,1.3,0.6,1.3,1.3v5.9c0,0.7-0.6,1.3-1.3,1.3h-39c-0.7,0-1.4-0.6-1.4-1.3v-5.9 C53.2,97.8,53.8,97.2,54.6,97.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M107,36.7l-4.5,2.9c-0.3,0.2-0.6,0.3-0.9,0.3h-0.7c-0.4,0-0.7-0.1-1-0.3l-3.8-2.8c-0.4-0.3-0.7-0.8-0.7-1.4 v-9.9c0-0.9,0.8-1.7,1.7-1.7l0,0h9c0.9,0,1.7,0.8,1.7,1.7l0,0v9.8C107.8,35.8,107.5,36.4,107,36.7z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 101.4,
    cy: 31.3,
    r: 2.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 39.5,
    className: "st7",
    width: 1.3,
    height: 90.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M76.3,56.3h53.1c1,0,1.8,0.8,1.8,1.8v8.1c0,1-0.8,1.8-1.8,1.8H76.3c-1,0-1.8-0.8-1.8-1.8v-8.1 C74.4,57.1,75.3,56.3,76.3,56.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_3_",
    cx: 81.4,
    cy: 62.1,
    r: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M83.4,65.1v0.5c0,0.1-0.1,0.1-0.1,0.1h-3.8c-0.1,0-0.1,0-0.1-0.1v-0.5c0-0.6,0.4-1,1-1 c0.2,0,0.4-0.1,0.4-0.2c0.1-0.1,0.1-0.2,0.1-0.4l0,0c-0.5-0.2-0.8-0.7-0.8-1.2l0,0c-0.2,0-0.3-0.1-0.3-0.3v-0.6 c0-0.5,0.1-1,0.5-1.3c0.6-0.4,1.3-0.5,2-0.2c0,0,0,0,0,0L82.2,60 M82.2,60.1L82.2,60.1c0.5,0,0.9,0.2,1.1,0.6l0,0 c-0.1,0.1-0.2,0.3-0.2,0.5v0.7c0,0.2-0.1,0.3-0.3,0.3c0,0,0,0,0,0l0,0l0,0c0,0.5-0.3,1-0.8,1.2l0,0c0,0.1,0,0.3,0.1,0.4 c0.1,0.2,0.2,0.3,0.4,0.3c0.6,0,1,0.4,1,1L82.2,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M83.4,65.1v0.5c0,0.1-0.1,0.1-0.1,0.1h-3.8c-0.1,0-0.1,0-0.1-0.1v-0.5c0-0.6,0.4-1,1-1 c0.2,0,0.4-0.1,0.4-0.2c0.3,0.3,0.8,0.3,1.2,0c0.1,0.2,0.3,0.2,0.4,0.2C83.1,64.1,83.5,64.6,83.4,65.1L83.4,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M83.3,60.7L83.3,60.7c-0.1,0.1-0.2,0.3-0.2,0.5v0.7c0,0.2-0.1,0.3-0.3,0.3c0,0,0,0,0,0v-0.8 c0-0.3-0.3-0.6-0.6-0.6c0,0,0,0,0,0h-1.3c-0.3,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0v0.8c-0.2,0-0.3-0.1-0.3-0.3v-0.5 c0-0.5,0.1-1,0.5-1.3c0.6-0.4,1.3-0.5,2-0.2c0,0,0,0,0,0L82.2,60 M82.2,60.1L82.2,60.1c0.5,0,0.9,0.2,1.1,0.6L82.2,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M82.7,62.3c0.1,0.7-0.5,1.3-1.2,1.4c-0.7,0.1-1.3-0.5-1.4-1.2c0-0.1,0-0.2,0-0.2v-0.8c0-0.3,0.3-0.6,0.6-0.6 c0,0,0,0,0,0h1.3c0.3,0,0.6,0.3,0.6,0.6c0,0,0,0,0,0V62.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.5,65.4h-0.3c-0.1,0-0.1,0-0.1-0.1s0-0.1,0.1-0.1h0.3C82.6,65.2,82.6,65.3,82.5,65.4 C82.6,65.4,82.6,65.4,82.5,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M81.1,63.1c0.1,0,0.1,0.2,0.1,0.3s-0.2,0.1-0.3,0.1l0,0c-0.5-0.2-0.8-0.7-0.8-1.2v-0.8c0-0.1,0-0.2,0.1-0.3 c0-0.1,0.1-0.1,0.2,0c0,0,0.1,0.1,0.1,0.1V62C80.5,62.5,80.8,62.9,81.1,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M81.9,63.7c-0.3,0.1-0.7,0.1-1,0c0-0.1,0-0.1,0-0.2l0,0c0.3,0.1,0.7,0.1,1,0l0,0 C81.9,63.5,81.9,63.6,81.9,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M80.9,64.4c0,0-0.1,0-0.2,0c-0.6,0-1,0.4-1,1v0.1c0,0.1-0.1,0.2-0.2,0.2l0,0h-0.1c-0.1,0-0.1,0-0.1-0.1v-0.5 c0-0.6,0.4-1,1-1c0.2,0,0.4-0.1,0.5-0.2L81,64c0.1,0.1,0.2,0.2,0.1,0.3C81.1,64.3,81.1,64.4,80.9,64.4L80.9,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M81.9,64.4c0,0,0.1,0,0.2,0c0.6,0,1,0.4,1,1v0.1c0,0.1,0.1,0.2,0.2,0.2h0.1c0.1,0,0.1,0,0.1-0.1v-0.5 c0-0.6-0.4-1-1-1c-0.2,0-0.4-0.1-0.4-0.2L81.9,64c-0.1,0.1-0.2,0.2-0.1,0.3C81.8,64.3,81.8,64.4,81.9,64.4L81.9,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.4,59.9C82.2,60,82.2,60,82.2,60c-0.8-0.2-1.6,0.2-1.8,1l0,0c-0.1,0.1-0.1,0.3-0.2,0.4v0.5 c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0v-0.5c0-0.5,0.1-1,0.5-1.3C80.9,59.7,81.7,59.6,82.4,59.9 C82.3,59.9,82.4,59.9,82.4,59.9z"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88.5,60.9h38.1c0.7,0,1.2,0.5,1.2,1.2v0c0,0.7-0.5,1.2-1.2,1.2H88.5c-0.7,0-1.2-0.5-1.2-1.2v0 C87.3,61.5,87.8,60.9,88.5,60.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.9,101.9l0.5-1.7h-0.3l-0.1,0.3c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.6,0.2 c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.2-0.2l0,0 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.2-0.4,0.3-0.6 c0.1-0.2,0.1-0.5,0.1-0.7c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.3-0.5-0.5-0.7c-0.2-0.2-0.5-0.3-0.8-0.4c-0.3-0.1-0.6-0.2-0.9-0.2 c-0.3,0-0.7,0.1-1,0.2c-0.3,0.1-0.6,0.3-0.8,0.5c-0.2,0.2-0.4,0.5-0.5,0.8c-0.1,0.3-0.2,0.7-0.2,1c0,0.3,0.1,0.7,0.2,1 c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.6c0.3,0.1,0.7,0.2,1,0.2c0.4,0,0.8-0.1,1.1-0.3c0.3-0.2,0.6-0.4,0.9-0.7l0,0L61,103 l0,0c-0.2,0.3-0.5,0.5-0.8,0.6c-0.3,0.2-0.7,0.2-1,0.2c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.4-0.5-0.5-0.7 c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.6,0.2-1.2,0.6-1.6c0.2-0.2,0.4-0.4,0.7-0.5c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6,0,0.8,0.1 c0.2,0.1,0.5,0.2,0.7,0.4c0.4,0.3,0.6,0.8,0.6,1.3c0,0.2,0,0.4-0.1,0.6c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.2,0.3-0.3,0.3 c-0.1,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.1,0-0.2C59.8,102.1,59.9,102,59.9,101.9z  M59.8,101.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.4-0.2 c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.2,0-0.4,0.1-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.2,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.1,0.5-0.1 c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.2C59.8,101.1,59.8,101.3,59.8,101.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.3,100.7h25.3c0.4,0,0.8,0.4,0.8,0.8l0,0c0,0.4-0.4,0.8-0.8,0.8H65.3c-0.4,0-0.8-0.4-0.8-0.8l0,0 C64.5,101.1,64.9,100.7,65.3,100.7z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M25,32.5c2.8-0.5,5.6-0.6,8.5-0.7c1.4,0,2.9,0.1,4.2,0.1c1.4,0,2.8-0.1,4.3,0c-1.4,0.3-2.8,0.6-4.2,0.7 c-1.4,0.2-2.8,0.1-4.3,0.2C30.6,32.9,27.8,32.8,25,32.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M32.6,24.9c1.6,0,3,0.3,4.5,0.5c1.5,0.3,2.9,0.5,4.4,1c-1.5,0.3-3.1,0.3-4.6,0C35.5,26.1,34,25.7,32.6,24.9z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M33.3,13.7c1.8,1.3,3.4,2.7,5,4c1.6,1.3,3.3,2.6,4.9,4.1c-2-0.8-3.9-1.9-5.6-3.3 C36,17.1,34.4,15.5,33.3,13.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M46.1,8c0.8,1.4,1.4,2.8,2,4.2c0.6,1.4,1.2,2.8,1.7,4.3c-1.2-1.1-2-2.4-2.6-3.9C46.5,11.1,46.1,9.6,46.1,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M56.2,4.7c0.1,2.1,0,4.1,0,6.2c0,2,0.1,4.1,0,6.2c-0.7-2-1-4.1-1-6.2C55.2,8.8,55.4,6.7,56.2,4.7z"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 84.8,
    transform: "matrix(0.9775 -0.211 0.211 0.9775 -20.2687 6.312)",
    className: "st18",
    width: 27.9,
    height: 26.6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st19",
    points: "31.2,80 3.9,85.9 9.5,111.9 36.8,106 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 90.5,
    transform: "matrix(0.9775 -0.211 0.211 0.9775 -19.8543 6.5109)",
    className: "st20",
    width: 12.2,
    height: 11.6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M41.9,113.6c-3.2,1.1-6.5,2.1-9.9,2.9c-1.7,0.4-3.3,0.8-5,1.1c-1.7,0.2-3.4,0.4-5.2,0.3c0,0,0,0,0-0.1 c0,0,0,0,0,0c1.7-0.5,3.3-0.9,5-1.2c1.7-0.4,3.4-0.6,5-0.9C35.3,115.1,38.6,114.3,41.9,113.6C41.9,113.5,42,113.5,41.9,113.6 C42,113.5,42,113.6,41.9,113.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M45.9,116.2c-3.2,1.1-6.5,2.1-9.9,2.9c-1.7,0.4-3.3,0.8-5,1.1c-1.7,0.2-3.4,0.4-5.2,0.3c0,0,0,0,0-0.1 c0,0,0,0,0,0c1.7-0.5,3.3-0.9,5-1.2c1.7-0.4,3.4-0.6,5-0.9C39.2,117.7,42.6,117,45.9,116.2C45.9,116.1,46,116.1,45.9,116.2 C46,116.2,46,116.2,45.9,116.2z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M262.4,47.4c-3.4-0.7-6.7-1.6-10-2.6c-1.6-0.5-3.3-1-4.9-1.7c-1.6-0.7-3.1-1.4-4.6-2.4c0,0,0,0,0-0.1 c0,0,0,0,0.1,0c1.7,0.4,3.3,1,4.9,1.5c1.6,0.6,3.2,1.2,4.8,1.8C255.9,45.2,259.1,46.3,262.4,47.4C262.4,47.3,262.4,47.3,262.4,47.4 C262.4,47.4,262.4,47.4,262.4,47.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M264.4,51.7c-3.4-0.7-6.7-1.6-10-2.6c-1.6-0.5-3.3-1-4.9-1.7c-1.6-0.7-3.1-1.4-4.6-2.4c0,0,0,0,0-0.1 c0,0,0,0,0.1,0c1.7,0.4,3.3,1,4.9,1.5c1.6,0.6,3.2,1.2,4.8,1.8C257.9,49.5,261.2,50.6,264.4,51.7C264.5,51.6,264.5,51.6,264.4,51.7 C264.5,51.7,264.5,51.7,264.4,51.7z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240.2,
    y: 64,
    transform: "matrix(0.9658 0.2592 -0.2592 0.9658 28.6246 -63.0823)",
    className: "st22",
    width: 26.7,
    height: 25.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 239.2,
    y: 62.4,
    transform: "matrix(0.9658 0.2592 -0.2592 0.9658 28.1602 -62.8805)",
    className: "st19",
    width: 26.7,
    height: 25.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "244.2,77.3 254.3,70 256.4,81.7 "
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 180.6,
    cy: 118.4,
    r: 4.1
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M189.7,147c0,0-10.1-24.9-8.5-27.1c0,0,0.6-3.1,5,9.1l6.4,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.3,141.2l-3.6-7.3c-2.6-4-3.6-0.1-3.6-0.1l5.1,11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.8,139.3c-3.4-8.3-4.8-4.8-5.4-4.7c0,0,0,0,0,0l-2,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.8,136.6c0,0,2.8-2,4.1,3.1c0,0,3.4,15.3,10.1,18.5l-12.9,6.5c0,0-4.3-8.9-9.3-14c-1.7-1.7-3-3.9-3.5-6.3 c-0.4-2.1-0.1-4.5,0.8-5.9c0,0,3.2,6.8,3.6,8.4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M190.1,147c-1.9-4.4-3.7-8.8-5.3-13.3c-0.8-2.2-1.6-4.5-2.3-6.8c-0.3-1.1-0.7-2.3-1-3.5 c-0.1-0.6-0.3-1.2-0.3-1.8c0-0.3-0.1-0.6-0.1-0.9c0-0.3,0-0.7,0.3-1.1l-0.1,0.1c0-0.2,0.1-0.3,0.3-0.5c0.2-0.2,0.6-0.1,0.7,0 c0.3,0.2,0.5,0.4,0.6,0.6c0.3,0.4,0.5,0.8,0.8,1.2c0.5,0.8,0.8,1.7,1.2,2.6c0.7,1.7,1.4,3.5,2,5.3l0,0l3.1,6.7c1,2.3,2,4.5,3,6.8 c-1.1-2.2-2.3-4.4-3.4-6.6l-3.3-6.6l0,0l0,0c-0.6-1.7-1.3-3.5-2-5.2c-0.4-0.8-0.8-1.7-1.2-2.5c-0.2-0.4-0.5-0.8-0.7-1.1 c-0.1-0.2-0.3-0.3-0.4-0.4c-0.1,0,0,0,0,0c0,0,0,0,0,0.1l0,0.1l-0.1,0.1c-0.1,0.1-0.1,0.4-0.1,0.6c0,0.3,0,0.6,0.1,0.8 c0.1,0.6,0.2,1.2,0.3,1.7c0.3,1.1,0.6,2.3,0.9,3.4c0.7,2.3,1.4,4.5,2.2,6.8C186.8,138.1,188.4,142.6,190.1,147z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M188.6,133.7c0.1-0.4,0.2-0.9,0.4-1.3c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.5-0.2,0.8-0.1 c0.5,0.1,0.9,0.4,1.2,0.8c0.3,0.3,0.6,0.7,0.9,1.1l0,0l0,0c1.2,2.4,2.4,4.9,3.2,7.5c-1.5-2.3-2.7-4.7-3.9-7.2l0,0 c-0.2-0.4-0.5-0.7-0.7-1c-0.3-0.3-0.6-0.6-0.9-0.7c-0.3-0.1-0.7,0-1,0.3C188.9,132.9,188.7,133.3,188.6,133.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M192.7,134.5c0.3-0.2,0.5-0.5,0.8-0.8c0.3-0.2,0.8-0.3,1.2-0.1c0.8,0.3,1.3,1,1.7,1.6c0.4,0.6,0.8,1.3,1,2 c0.3,0.7,0.5,1.4,0.7,2.1c-0.4-0.6-0.8-1.2-1.1-1.9c-0.2-0.3-0.3-0.6-0.5-0.9c-0.2-0.3-0.4-0.6-0.6-0.9c-0.4-0.6-0.8-1.2-1.3-1.5 c-0.3-0.1-0.6-0.2-0.9-0.1C193.4,134.1,193.1,134.5,192.7,134.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M198.5,164.7c-1.3-2.2-2.6-4.3-4-6.4c-1.4-2.1-2.8-4.2-4.4-6.1c-0.8-0.9-1.7-1.8-2.5-2.9 c-0.7-1-1.3-2.2-1.7-3.4c-0.4-1.2-0.6-2.5-0.7-3.8c-0.1-1.3-0.1-2.6,0.6-3.8l0.1-0.3l0.1,0.3c0.7,1.4,1.4,2.8,2.1,4.2 c0.3,0.7,0.7,1.4,1,2.1c0.3,0.7,0.6,1.4,0.9,2.2c-0.2-0.7-0.6-1.4-0.9-2.1c-0.3-0.7-0.7-1.4-1.1-2.1c-0.7-1.4-1.5-2.7-2.3-4.1 l0.3,0c-0.6,1.1-0.6,2.4-0.5,3.6c0.1,1.2,0.3,2.5,0.7,3.6c0.4,1.2,1,2.3,1.7,3.3c0.7,1,1.7,1.8,2.5,2.8c0.9,0.9,1.6,1.9,2.4,3 c0.7,1,1.4,2.1,2.1,3.2C196.4,160.1,197.6,162.4,198.5,164.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M197.2,136.6c0.5-0.3,1.1-0.5,1.7-0.4c0.6,0.1,1.1,0.5,1.5,0.9c0.8,0.9,1.1,2.1,1.4,3.2 c0.6,2.2,1.3,4.4,2.2,6.6c0.8,2.2,1.8,4.3,2.9,6.2c0.3,0.5,0.6,1,0.9,1.4c0.3,0.5,0.7,0.9,1,1.4c0.3,0.5,0.8,0.8,1.2,1.2 c0.2,0.2,0.4,0.4,0.7,0.5l0.7,0.5c-2.2-0.9-3.7-2.8-5-4.8c-1.3-2-2.2-4.1-3.1-6.3c-0.8-2.2-1.5-4.4-2-6.7 c-0.2-1.1-0.5-2.2-1.1-3.2c-0.3-0.5-0.7-0.8-1.3-1C198.3,136.3,197.7,136.4,197.2,136.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvImport);
export default __webpack_public_path__ + "static/media/csvImport.b225761223a151a0aeddc55dd0dd9ec6.svg";
export { ForwardRef as ReactComponent };